import React, { useEffect } from 'react';
import { HeadingTwo } from '@marty-js/design/src/atoms/h2';
import { LinkList } from '@marty-js/design/src/molecules/link-list';
import styled from 'styled-components';
import type { ItemSidebarComponentLinkCollectionType } from '../types';

const ListItemRow = styled.ul`
  display: flex;
  flex-direction: column;
`;

const LinkCollection: React.FC<ItemSidebarComponentLinkCollectionType> = ({ data, setIsIamSticky }) => {
  useEffect(() => {
    setIsIamSticky?.(false);
  }, [setIsIamSticky]);

  return (
    <>
      {data.info?.title ? (
        <HeadingTwo className="mod-without-mt" as="div">
          {data.info?.title}
        </HeadingTwo>
      ) : null}
      <ListItemRow>
        {data?.links?.data?.map((link, key) => {
          return <LinkList key={key} title={link.title} url={link.url} />;
        })}
      </ListItemRow>
    </>
  );
};

export default LinkCollection;
